import Vue from 'vue';
import Vuex from 'vuex';
import Env from '@/env';
import createPersistedState from 'vuex-persistedstate';
import createMutationsSharer from "vuex-shared-mutations";
import PubNubVue from 'pubnub-vue';

import AuthApis from '@/controllers/AuthApis';

import snackbar from '@/store/modules/snackbar';
import spinner from '@/store/modules/spinner';
import logoutspinner from '@/store/modules/logoutspinner';
import auth from '@/store/modules/auth';
import mainproduct from '@/store/modules/mainproduct';
import menu from '@/store/modules/menu';

// superadmin
import superadmin_reg_product from '@/store/modules/superadmin_reg_product';
import superadmin_customer from '@/store/modules/superadmin_customer';
import superadmin_reseller from '@/store/modules/superadmin_reseller';
import pdf from '@/store/modules/pdf';


// distributor
import distributor_reg_products from '@/store/modules/distributor_reg_products';

// register user
import register_user from '@/store/modules/register_user';

// reseller modules
import reseller_reg_products from '@/store/modules/reseller_reg_products';
import reseller_customer from '@/store/modules/reseller_customer';

// distributor
import distributor_customer from '@/store/modules/distributor_customer';

// customer

import customer_reg_products from '@/store/modules/customer_reg_products';

const initialState = {
  spinner: spinner.state,
  logoutspinner: logoutspinner.state,
  snackbar: snackbar.state,
  menu: menu.state,
  auth: auth.state,
  mainproduct: mainproduct.state,
  superadmin_reg_product: superadmin_reg_product.state,
  superadmin_customer: superadmin_customer.state,
  superadmin_reseller: superadmin_reseller.state,
  pdf: pdf.state,
  register_user: register_user.state,

  // distributor
  distributor_reg_products: distributor_reg_products.state,
  distributor_customer: distributor_customer.state,

  // reseller
  reseller_reg_products: reseller_reg_products.state,
  reseller_customer: reseller_customer.state,

  // customer
  customer_reg_products: customer_reg_products.state,
};

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    spinner,
    logoutspinner,
    snackbar,
    menu,
    auth,
    mainproduct,
    superadmin_reg_product,
    superadmin_customer,
    superadmin_reseller,
    pdf,
    register_user,

    distributor_reg_products,
    distributor_customer,

    reseller_reg_products,
    reseller_customer,

    customer_reg_products,
  },
  plugins: [
    createPersistedState(),
    createMutationsSharer({
      predicate: [
        'auth/user',
        'clearAppDataMutate',
      ]
    }),
  ],
  mutations: {
    clearAppDataMutate(state) {
      Object.keys(state).forEach((key) => {
        Object.assign(state[key], initialState[key]);
      });
    },
  },
  actions: {
    async clearAppData({ commit }) {
      commit('clearAppDataMutate');

      const url = `${Env.baseUrl}/logout`;
      return await AuthApis.postApi(url, {})
      .then( res => {
        let pubnub = PubNubVue.getInstance();
        pubnub.unsubscribeAll(); 
        return res;
      }).catch(err => {
        let pubnub = PubNubVue.getInstance();
        pubnub.unsubscribeAll();
        return err;
      })
      // release al channels
    
    },
  },
})